module.exports = __webpack_public_path__ + "img/dzjqr-xcbgl.99d2418f.png";